export function showLoadingSpinner() {
  console.log('LOADING........');
  const spinner = document.getElementById('loadingSpinner');
  spinner.style.display = 'flex';
}

export function hideLoadingSpinner() {
  const spinner = document.getElementById('loadingSpinner');
  spinner.style.display = 'none';
}
